export default {
  //preset time and humanized time are both "humanized" but preset time only has min and secs
  presetTime: 'Humanized Time', //MMmSSs TimeUtil.getFormattedPresetDuration()
  clockTime: 'Clock Time', //MM:SS TimeUtil.getShorthandFormattedPresetDuration()
  sixDigitTime: 'Six Digit Time', //HH:MM:SS TimeUtil.getFormattedDuration()
  humanizedTime: 'Humanized Time', //HHhMMmSSs TimeUtil.getShorthandDuration()
};
